import React, { useEffect, useState, useMemo } from "react";
import Table from "../../core/common/dataTable/index";
import { contactMessagesData } from "../../core/data/json/contactMessages";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { initialSettings } from "../../core/common/selectoption/selectoption";
import DateRangePicker from "react-bootstrap-daterangepicker";
import CollapseHeader from "../../core/common/collapse-header";
import {
  createContentMessager,
  deleteContentMessager,
  getAllContentMessagers,
  updateContentMessager, // Assuming an update API exists
} from "../../api/contentmessages";
import { toast } from "react-toastify";
import { fetchAllLeads, Lead } from "../../api/lead";
import { Client, fetchAllClients } from "../../api/todo";
import Select from "react-select";
import { useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";
import { ClientDetails, fetchClientById } from "../../api/client";
import { highlightMatch } from "../../core/common/highlightmatch";
import { ColumnsType } from "antd/es/table";
import { Avatar } from "antd";

const route = all_routes;
interface ContentMessage {
  content_id: string;
  content_name?: string;
  DLT_templete_name_or_id?: string;
  content_type?: string;
  DLT_operator_name?: string;
  created_at: string; // Adjust to Date if your API returns Date objects
  updated_at?: string;
  created_by?: string;
  // Include last_viewed only if supported by your API
  last_viewed?: string;
  // Add other fields from your API response if needed
}
const ContentMessages = () => {
  const [loading, setLoading] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState<string | null>(
    null
  );
  const [activeRangeLabel, setActiveRangeLabel] =
    useState<string>("Last 7 Days");
  const [selectedType, setSelectedType] = useState("");

  // State for form fields (shared for Add and Edit forms)
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [access, setAccess] = useState("");
  const [sharedOwners, setSharedOwners] = useState<string[]>([]);
  const [description, setDescription] = useState("");
  const [module, setModule] = useState("");
  const [leadFields, setLeadFields] = useState<string[]>([]);
  const [agentFields, setAgentFields] = useState<string[]>([]);
  const [moreTags, setMoreTags] = useState<string[]>([]);
  const [message, setMessage] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [error, setError] = useState<string | null>(null);



  // SMS Specific
  const [dltTemplateId, setDltTemplateId] = useState("");
  const [dltApproved, setDltApproved] = useState("");
  const [dltOperatorName, setDltOperatorName] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [senderId, setSenderId] = useState("");

  // WhatsApp Specific
  const [whatsappTemplateId, setWhatsappTemplateId] = useState("");
  const [whatsappType, setWhatsappType] = useState("text");
  const [mediaType, setMediaType] = useState("");
  const [mediaFile, setMediaFile] = useState<File | null>(null);
  // Inside your component
  const clientId = useSelector((state: RootState) => state.auth.client_id);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [clientDetail, setClientDetail] = useState<ClientDetails | null>(null);
  const [dataSource, setDataSource] = useState<ContentMessage[]>([]);
  const [filteredData, setFilteredData] = useState<ContentMessage[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [sortKey, setSortKey] = useState<keyof ContentMessage>(
    "DLT_templete_name_or_id"
  );
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const [dateRange, setDateRange] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({ startDate: null, endDate: null });
  useEffect(() => {
    let result = [...dataSource];

    // Search filter
    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      result = result.filter(
        (item) =>
          item.DLT_templete_name_or_id?.toLowerCase().includes(lowerQuery) ||
          item.content_type?.toLowerCase().includes(lowerQuery) ||
          item.DLT_operator_name?.toLowerCase().includes(lowerQuery)
      );
    }

    // Date range filter
    if (dateRange.startDate && dateRange.endDate) {
      result = result.filter((item) => {
        const createdDate = new Date(item.created_at);
        const start = new Date(dateRange.startDate as Date);
        const end = new Date(dateRange.endDate as Date);
        return createdDate >= start && createdDate <= end;
      });
    }
    // Sorting
    result.sort((a, b) => {
      const valA = a[sortKey] || "";
      const valB = b[sortKey] || "";

      return sortOrder === "asc"
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });
    if (selectedType && selectedType !== "All") {
      result = result.filter((item) => item.content_type === selectedType);
    }

    setFilteredData(result);
  }, [searchQuery, sortKey, sortOrder, dateRange, dataSource, selectedType]);
  useEffect(() => {
    fetchAllLeads().then(setLeads);
    if (clientId) fetchClientById(clientId).then(setClientDetail);
  }, [clientId]);

  // Fetch messages on component mount
  const fetchMessages = async () => {
    setLoading(true);
    try {
      const data = await getAllContentMessagers();
      setDataSource(data);
    } catch (error) {
      console.error("Failed to load content messages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  // Updated message appending logic to avoid duplicates
  const updateMessageWithFields = (
    newFields: string[],
    existing: string[],
    setFn: any
  ) => {
    const uniqueFields = newFields.filter((f) => !existing.includes(f));
    if (uniqueFields.length > 0) {
      setFn([...existing, ...uniqueFields]);
      const newTags = uniqueFields.map((v) => `[${v}]`).join(" ");
      setMessage((prev) => `${prev} ${newTags}`);
    }
  };

  const resolveContentType = (value: string) => {
    switch (value) {
      case "1":
        return "email";
      case "2":
        return "sms";
      case "3":
        return "whats_app";
      default:
        return "mannual";
    }
  };

  // Handle form submit for both Add and Edit
  const handleSubmit = async (e: React.FormEvent, isEdit = false) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("content_name", name);
    formData.append("content_type", resolveContentType(type));
    formData.append("content_access", access.toLowerCase());
    formData.append("creat_tags", tags.join(","));
    formData.append("content_description", description);
    if (access === "Shared To")
      formData.append("shared_owners", sharedOwners.join(","));

    if (type === "1") {
      formData.append("module", module);
      formData.append("lead_field", leadFields.join(","));
      formData.append("agent_field", agentFields.join(","));
      formData.append("more_tags", moreTags.join(","));
      formData.append("message", message);
    } else if (type === "2") {
      formData.append("DLT_templete_name_or_id", dltTemplateId);
      formData.append("DLT_approved", dltApproved);
      formData.append("DLT_operator_name", dltOperatorName);
      formData.append("service_type", serviceType);
      formData.append("sender_id", senderId);
      formData.append("module", module);
      formData.append("lead_field", leadFields.join(","));
      formData.append("agent_field", agentFields.join(","));
      formData.append("message", message);
    } else if (type === "3") {
      formData.append("DLT_templete_name_or_id", whatsappTemplateId);
      formData.append("templet_type", whatsappType);
      if (whatsappType === "media") {
        formData.append("media_type", mediaType);
        if (mediaFile) formData.append("attachment", mediaFile);
      }
      formData.append("module", module);
      formData.append("lead_field", leadFields.join(","));
      formData.append("agent_field", agentFields.join(","));
      formData.append("message", message);
    }

    try {
      if (isEdit && selectedContentId) {
        await updateContentMessager(selectedContentId, formData); // Assuming an update API
        toast.success("Message updated");
      } else {
        await createContentMessager(formData);
        toast.success("Message created");
      }
      fetchMessages(); // Refresh table
      // Reset form fields
      resetForm();
    } catch (err) {
      console.error(isEdit ? "Error updating message" : "Error saving message");
    }
  };

  // Reset form fields
  const resetForm = () => {
    setName("");
    setType("");
    setTags([]);
    setAccess("");
    setSharedOwners([]);
    setDescription("");
    setModule("");
    setLeadFields([]);
    setAgentFields([]);
    setMoreTags([]);
    setMessage("");
    setDltTemplateId("");
    setDltApproved("");
    setDltOperatorName("");
    setServiceType("");
    setSenderId("");
    setWhatsappTemplateId("");
    setWhatsappType("text");
    setMediaType("");
    setMediaFile(null);
  };

  // Handle delete
  const handleDelete = async () => {
    if (!selectedContentId) return;
    try {
      await deleteContentMessager(selectedContentId);
      toast.success("Deleted successfully");
      fetchMessages();
    } catch (error) {
      console.error("Delete failed");
    } finally {
      setSelectedContentId(null);
    }
  };

  const handleEdit = (record: any) => {
    setSelectedContentId(record.content_id);
    setName(record.content_name || "");
    setType(
      record.content_type === "email"
        ? "1"
        : record.content_type === "sms"
          ? "2"
          : record.content_type === "whats_app"
            ? "3"
            : ""
    );
    setTags(record.creat_tags ? record.creat_tags.split(",") : []);
    setAccess(
      record.content_access
        ? record.content_access.charAt(0).toUpperCase() +
        record.content_access.slice(1)
        : ""
    );
    setSharedOwners(
      record.shared_owners ? record.shared_owners.split(",") : []
    );
    setDescription(record.content_description || "");
    setModule(record.module || "");
    setLeadFields(record.lead_field ? record.lead_field.split(",") : []);
    setAgentFields(record.agent_field ? record.agent_field.split(",") : []);
    setMoreTags(record.more_tags ? record.more_tags.split(",") : []);
    setMessage(record.message || "");
    setDltTemplateId(record.DLT_templete_name_or_id || "");
    setDltApproved(record.DLT_approved || "");
    setDltOperatorName(record.DLT_operator_name || "");
    setServiceType(record.service_type || "");
    setSenderId(record.sender_id || "");
    setWhatsappTemplateId(record.DLT_templete_name_or_id || "");
    setWhatsappType(record.templet_type || "text");
    setMediaType(record.media_type || "");
  };

  const baseColumns: ColumnsType<ContentMessage> = [
    {
      title: "Name",
      dataIndex: "content_name",
      key: "content_name",
      render: (_: any, record: ContentMessage) => {
        const name =
          (record.content_name
            ? record.content_name.charAt(0).toUpperCase() + record.content_name.slice(1)
            : "N/A");

        const initial = name.charAt(0) || "";

        const contentType = record.content_type
          ?.replace(/_/g, " ")
          ?.replace(/\b\w/g, (char) => char.toUpperCase()) || "N/A";

        return (
          <div className="d-flex align-items-center gap-2">
            <Avatar
              shape="square"
              style={{
                backgroundColor: "#ff4d4f",
                border: "2px solid #ff4d4f",
                width: 36,
                height: 36,
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              {initial}
            </Avatar>

            <div className="d-flex flex-column">
              <Link to="#" className="fw-semibold text-dark">
                {highlightMatch(name, searchQuery)}
              </Link>
              <span className="text-muted small">
                {highlightMatch(contentType, searchQuery)}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "content_type",
      key: "content_type",
      render: (type: string) => {
        let iconClass = "";
        let label = "";

        switch (type) {
          case "email":
            iconClass = "ti ti-mail me-1 text-primary";
            label = "Email";
            break;
          case "sms":
            iconClass = "ti ti-message-circle-2 me-1 text-success";
            label = "SMS";
            break;
          case "whats_app":
            iconClass = "ti ti-brand-whatsapp me-1 text-success";
            label = "WhatsApp";
            break;
          default:
            label = type;
            break;
        }
        return (
          <span className="d-inline-flex align-items-center">
            {iconClass && <i className={iconClass} />}
            {highlightMatch(label, searchQuery)}
          </span>
        );
      },
    },
  ];
  const smsColumns: ColumnsType<ContentMessage> = [
    {
      title: "DLT ID",
      dataIndex: "DLT_templete_name_or_id",
      key: "DLT_templete_name_or_id",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "DLT Approved",
      dataIndex: "DLT_approved",
      key: "DLT_approved",
      render: (val: string) => {
        let badgeClass = "";
        let iconClass = "";
        let label = val;

        switch (val) {
          case "approved":
            badgeClass = "badge-success";
            iconClass = "ti ti-circle-check me-1"; // green check icon
            break;
          case "pending":
            badgeClass = "badge-warning";
            iconClass = "ti ti-clock me-1"; // clock icon
            break;
          case "rejected":
          default:
            badgeClass = "badge-danger";
            iconClass = "ti ti-circle-x me-1"; // red cross icon
            break;
        }

        return (
          <span className={`badge ${badgeClass} d-inline-flex align-items-center`}>
            <i className={iconClass} />
            {highlightMatch(label, searchQuery)}
          </span>
        );
      },
    },
    {
      title: "Operator",
      dataIndex: "DLT_operator_name",
      key: "DLT_operator_name",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "Sender ID",
      dataIndex: "sender_id",
      key: "sender_id",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "Service Type",
      dataIndex: "service_type",
      key: "service_type",
      render: (val: string) => {
        let badgeClass = "";
        let iconClass = "";
        let label = "";

        switch (val) {
          case "promotional":
            badgeClass = "badge-danger"; // red
            iconClass = "ti ti-speakerphone me-1"; // megaphone icon
            label = "Promotional";
            break;
          case "transactional":
            badgeClass = "badge-success"; // green
            iconClass = "ti ti-currency-rupee me-1"; // transaction icon
            label = "Transactional";
            break;
          case "service_explict":
            badgeClass = "badge-info"; // blue
            iconClass = "ti ti-user-check me-1"; // user check icon
            label = "Service Explicit";
            break;
          case "service_implict":
          default:
            badgeClass = "badge-warning"; // yellow/orange
            iconClass = "ti ti-user-exclamation me-1"; // warning/user icon
            label = "Service Implicit";
            break;
        }
        return (
          <span className={`badge ${badgeClass} d-inline-flex align-items-center`}>
            <i className={iconClass} />
            {highlightMatch(label, searchQuery)}
          </span>
        );
      },
    },
  ];
  const whatsappColumns: ColumnsType<ContentMessage> = [
    {
      title: "Template ID",
      dataIndex: "DLT_templete_name_or_id",
      key: "DLT_templete_name_or_id",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "Type",
      dataIndex: "templet_type",
      key: "templet_type",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "Media Type",
      dataIndex: "media_type",
      key: "media_type",
      render: (val: string) => highlightMatch(val, searchQuery),
    },
    {
      title: "Attachment",
      dataIndex: "Attachment",
      key: "Attachment",
      render: (val: string | null) =>
        val ? (
          <button
            className="btn btn-link d-flex align-items-center p-0"
            onClick={async () => {
              try {
                const token = localStorage.getItem("authToken");
                const response = await fetch(val, {
                  headers: {
                    Authorization: token ? `Bearer ${token}` : "",
                  },
                });

                if (!response.ok) throw new Error("Failed to fetch file");

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = val.split("/").pop() || "file";
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.error("Download failed", error);
              }
            }}
          >
            <i className="ti ti-download me-1" /> Download
          </button>
        ) : (
          <span className="text-muted">No file</span>
        ),
    },
  ];

  const emailColumns: ColumnsType<ContentMessage> = [
    {
      title: "Subject",
      dataIndex: "content_description",
      key: "content_description",
      render: (val: string) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: 200 }}
          title={val}
        >
          {highlightMatch(val, searchQuery)}
        </span>
      ),
    },
  ];
  const getColumnsByType = (
    type: "sms" | "whats_app" | "email"
  ): ColumnsType<ContentMessage> => {
    let typeSpecificCols: ColumnsType<ContentMessage> = [];

    if (type === "sms") typeSpecificCols = smsColumns;
    else if (type === "whats_app") typeSpecificCols = whatsappColumns;
    else if (type === "email") typeSpecificCols = emailColumns;

    return [
      ...baseColumns,
      ...typeSpecificCols,
      {
        title: "Created",
        dataIndex: "created_at",
        key: "created_at",
        render: (date: string) => {
          const parsed = new Date(date);
          if (!date || isNaN(parsed.getTime())) return "-";

          const dateStr = parsed.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          const timeStr = parsed.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });

          return (
            <div>
              <div>{dateStr}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>{timeStr}</div>
            </div>
          );
        },
        sorter: (a, b) =>
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      },
      {
        title: "Last Modified",
        dataIndex: "updated_at",
        key: "updated_at",
        render: (date: string) => {
          const parsed = new Date(date);
          if (!date || isNaN(parsed.getTime())) return "-";

          const dateStr = parsed.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          const timeStr = parsed.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });

          return (
            <div>
              <div>{dateStr}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>{timeStr}</div>
            </div>
          );
        },
        sorter: (a, b) =>
          new Date(a.updated_at ?? "").getTime() -
          new Date(b.updated_at ?? "").getTime(),
      },
      {
        title: "Created By",
        dataIndex: "created_by",
        key: "created_by",
        render: (text: string) => highlightMatch(text, searchQuery),
      },
      {
        title: "Action",
        key: "action",
        render: (_: any, record: ContentMessage) => (
          <div className="dropdown table-action">
            <Link
              to="#"
              className="action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link
  className="dropdown-item edit-popup"
  to="#"
  onClick={() => {
    handleEdit(record);  // load record into form
    setShowEdit(true);   // ✅ open offcanvas
  }}
>
  <i className="ti ti-edit text-blue"></i> Edit
</Link>

              <Link
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_contact"
                onClick={() => setSelectedContentId(record.content_id)}
              >
                <i className="ti ti-trash text-danger"></i> Delete
              </Link>
            </div>
          </div>
        ),
      },
    ];
  };

  const renderEditor = (
    fields: string[],
    message: string,
    onMessageChange: (val: string) => void
  ) => (
    <div className="row">
      {fields.map((label, idx) => (
        <div className="col-md-12" key={idx}>
          <div className="mb-3">
            <label className="col-form-label">
              {label === "Message" ? (
                <>
                  Message <span className="text-danger">*</span>
                  <br />
                  <small className="text-muted">
                    (use variables like {"{{tag}}"})
                  </small>
                </>
              ) : (
                <>
                  {label} <span className="text-danger">*</span>
                </>
              )}
            </label>
            {label === "Message" ? (
              <>
                <textarea
                  className="form-control"
                  rows={4}
                  value={message}
                  onChange={(e) => onMessageChange(e.target.value)}
                />
                <div className="text-end text-muted small mt-1">
                  {message.length} characters
                </div>
              </>
            ) : (
              <input type="text" className="form-control" />
            )}
          </div>
        </div>
      ))}
    </div>
  );

  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    {
      content_name: true,
      content_type: true,
      DLT_templete_name_or_id: true,
      DLT_approved: true,
      DLT_operator_name: true,
      sender_id: true,
      service_type: true,
      templet_type: true,
      media_type: true,
      Attachment: true,
      content_description: true,
      created_at: true,
      updated_at: true,
      created_by: true,
      action: true,
    }
  );

  const handleColumnToggle = (columnKey: string) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [columnKey]: !prev[columnKey],
    }));
  };

  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [filterNames, setFilterNames] = useState<string[]>([]);
  const [filterTypes, setFilterTypes] = useState<string[]>([]);
  const [filterCreatedAts, setFilterCreatedAts] = useState<string[]>([]);
  const [filterUpdatedAts, setFilterUpdatedAts] = useState<string[]>([]);
  const [filterCreatedBys, setFilterCreatedBys] = useState<string[]>([]);
  const [filterNamesSearch, setFilterNamesSearch] = useState("");
  const [filterTypesSearch, setFilterTypesSearch] = useState("");
  const [createdAtSearch, setCreatedAtSearch] = useState("");
  const [updatedAtSearch, setUpdatedAtSearch] = useState("");
  const [createdBySearch, setCreatedBySearch] = useState("");
  const [alphaFilter, setAlphaFilter] = useState<string>("All");

  const handleAccordionToggle = (key: string) => {
    setOpenAccordion((prev) => (prev === key ? null : key));
  };

  const handleFilterChange = (
    value: string,
    current: string[],
    setter: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (current.includes(value)) {
      setter(current.filter((v) => v !== value));
    } else {
      setter([...current, value]);
    }
  };

  const uniqueNames = useMemo(
    () =>
      Array.from(
        new Set(dataSource.map((d) => d.content_name?.trim() || ""))
      ).filter((n) => n),
    [dataSource]
  );

  const uniqueTypes = useMemo(
    () =>
      Array.from(
        new Set(dataSource.map((d) => d.content_type?.trim() || ""))
      ).filter((s) => s),
    [dataSource]
  );

  const uniqueCreatedAts = useMemo(() => {
    const formattedDates = dataSource
      .map((d) => {
        if (!d.created_at) return "";
        const date = new Date(d.created_at);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      })
      .filter((n) => n);

    return Array.from(new Set(formattedDates));
  }, [dataSource]);

  const uniqueUpdatedAts = useMemo(() => {
    const formattedDates = dataSource
      .map((d) => {
        if (!d.updated_at) return "";
        const date = new Date(d.updated_at);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      })
      .filter((n) => n);

    return Array.from(new Set(formattedDates));
  }, [dataSource]);

  const uniqueCreatedBys = useMemo(
    () =>
      Array.from(
        new Set(dataSource.map((d) => d.created_by?.trim() || ""))
      ).filter((s) => s),
    [dataSource]
  );

  const [sortOption, setSortOption] = useState<string>("recently_added");

  const filteredDataMemo = useMemo(() => {
    const q = searchQuery.toLowerCase();
    const filtered = dataSource.filter((item) => {
      const name = item.content_name?.toLowerCase() || "";
      const contentType = item.content_type?.toLowerCase() || "";
      const created = item.created_at
        ? new Date(item.created_at).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : "";
      const updated = item.updated_at
        ? new Date(item.updated_at).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : "";
      const createdBy = item.created_by?.toLowerCase() || "";

      const alphaMatch =
        alphaFilter === "All" ||
        (item.content_name || "").toLowerCase().startsWith(alphaFilter.toLowerCase());

      const matchName =
        filterNames.length === 0 ||
        filterNames.includes(item.content_name || "");

      const matchType =
        filterTypes.length === 0 ||
        filterTypes.includes(item.content_type || "");

      const matchCreated =
        filterCreatedAts.length === 0 || filterCreatedAts.includes(created);

      const matchUpdated =
        filterUpdatedAts.length === 0 || filterUpdatedAts.includes(updated);

      const matchCreatedBy =
        filterCreatedBys.length === 0 ||
        filterCreatedBys.includes(item.created_by || "");

      const matchesSearch =
        name.includes(q) ||
        contentType.includes(q) ||
        created.includes(q) ||
        updated.includes(q) ||
        createdBy.includes(q);

      let matchesDate = true;
      if (dateRange.startDate && dateRange.endDate) {
        const createdDate = new Date(item.created_at);
        const start = new Date(dateRange.startDate as Date);
        const end = new Date(dateRange.endDate as Date);
        matchesDate = createdDate >= start && createdDate <= end;
      }

      return (
        matchesSearch &&
        matchesDate &&
        matchName &&
        matchType &&
        matchCreated &&
        matchUpdated &&
        matchCreatedBy &&
        alphaMatch
      );
    });

    const sorted = [...filtered];
    if (sortOption === "ascending") {
      sorted.sort((a, b) =>
        (a.content_name || "").localeCompare(b.content_name || "")
      );
    } else if (sortOption === "descending") {
      sorted.sort((a, b) =>
        (b.content_name || "").localeCompare(a.content_name || "")
      );
    } else if (sortOption === "recently_added") {
      sorted.sort(
        (a, b) =>
          new Date(b.created_at || "").getTime() -
          new Date(a.created_at || "").getTime()
      );
    } else if (sortOption === "recently_viewed") {
      sorted.sort((a, b) => {
        const aTime = new Date(
          (a as any).last_viewed || a.created_at || ""
        ).getTime();
        const bTime = new Date(
          (b as any).last_viewed || b.created_at || ""
        ).getTime();
        return bTime - aTime;
      });
    }

    return sorted;
  }, [
    searchQuery,
    dataSource,
    sortOption,
    dateRange,
    filterNames,
    filterTypes,
    filterCreatedAts,
    filterUpdatedAts,
    filterCreatedBys,
    alphaFilter,
  ]);

  const columnsByType = getColumnsByType(selectedType as "sms" | "whats_app" | "email" || "All");
  const visibleCols = columnsByType.filter(
    (col) => visibleColumns[col.key as string]
  );

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title"><i className="ti ti-page-break text-primary me-2" />
                      Content Messages <span className="count-title">{dataSource.length}</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}

              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search User"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                        {/*  <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-package-export me-2" />
                            Export
                          </Link>
                          <div className="dropdown-menu dropdown-menu-end">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-pdf text-danger me-1" />
                                  Export as PDF
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-file-type-xls text-green me-1" />
                                  Export as Excel
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>*/}

                        <Link
  to="#"
  className="btn btn-primary"
  onClick={() => setShowAdd(true)}
>
  <i className="ti ti-square-rounded-plus me-2" />
  Add Content Messages
</Link>

                      </div>
                    </div>
                  </div>
                </div>

            
                  
                      <div className="d-flex align-items-center justify-content-between mb-1 flex-wrap gap-3 mb-3">
                  <div className="d-flex align-items-center flex-wrap gap-2">
                      <div className="dropdown me-2 ms-4">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-sort-ascending-2 me-2" />
                          Sort
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            {[
                              {
                                label: "Ascending",
                                key: "DLT_templete_name_or_id",
                                order: "asc",
                              },
                              {
                                label: "Descending",
                                key: "DLT_templete_name_or_id",
                                order: "desc",
                              },
                              {
                                label: "Recently Viewed",
                                key: "last_viewed",
                                order: "desc",
                              },
                              {
                                label: "Recently Added",
                                key: "created_at",
                                order: "desc",
                              },
                            ].map(({ label, key, order }) => {
                              const isActive =
                                sortKey === key && sortOrder === order;
                              return (
                                <li key={label}>
                                  <Link
                                    to="#"
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${isActive ? "fw-bold text-primary" : ""
                                      }`}
                                    onClick={() => {
                                      setSortKey(key as keyof ContentMessage);
                                      setSortOrder(order as "asc" | "desc");
                                    }}
                                  >
                                    <span>
                                      <i className="ti ti-circle-chevron-right me-1" />
                                      {label}
                                    </span>
                                    {isActive && <i className="ti ti-check" />}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>

                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-message-circle-2 me-2" />
                          Filter By Type
                        </Link>
                        <div className="dropdown-menu dropdown-menu-start">
                          <ul>
                            {["All", "email", "sms", "whats_app"].map(
                              (type) => {
                                const count = dataSource.filter((item) =>
                                  type === "All"
                                    ? true
                                    : item.content_type === type
                                ).length;
                                return (
                                  <li key={type}>
                                    <Link
                                      to="#"
                                      className={`dropdown-item ${selectedType === type
                                        ? "fw-bold text-primary"
                                        : ""
                                        }`}
                                      onClick={() => setSelectedType(type)}
                                    >
                                      {type === "All"
                                        ? "All Types"
                                        : type.toUpperCase()}{" "}
                                      ({count})
                                    </Link>
                                  </li>
                                );
                              }
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar" />
                        </span>
                        <DateRangePicker
                          initialSettings={initialSettings}
                          onCallback={(start, end, label) => {
                            setDateRange({
                              startDate: start.toDate(),
                              endDate: end.toDate(),
                            });
                            <DateRangePicker
                              initialSettings={initialSettings}
                              onCallback={(start, end, label) => {
                                setDateRange({
                                  startDate: start.toDate(),
                                  endDate: end.toDate(),
                                });
                                if (label) setActiveRangeLabel(label); // <- capture clicked label
                              }}
                            >
                              <input
                                className="form-control date-range bookingrange"
                                type="text"
                              />
                            </DateRangePicker>; // <- capture clicked label
                          }}
                        >
                          <input
                            className="form-control date-range bookingrange"
                            type="text"
                          />
                        </DateRangePicker>
                      </div>
                      
                      
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="btn bg-soft-purple text-purple"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-columns-3 me-2" />
                          Manage Columns
                        </Link>
                        <div
                          className="dropdown-menu dropdown-menu-end dropdown-md p-3"
                          style={{ minWidth: "250px" }}
                        >
                          <h4 className="mb-2 fw-semibold">Manage Columns</h4>
                          <p className="mb-3">
                            Drag and drop columns to reorder and toggle
                            visibility.
                          </p>
                          <div className="border-top pt-3">
                            {Object.keys(visibleColumns).map((colKey) => (
                              <div
                                className="d-flex align-items-center justify-content-between mb-3"
                                key={colKey}
                              >
                                <p className="mb-0 d-flex align-items-center text-capitalize">
                                  <i className="ti ti-grip-vertical me-2" />
                                  {colKey.replace(/_/g, " ")}
                                </p>
                                <div className="status-toggle">
                                  <input
                                    type="checkbox"
                                    className="check"
                                    id={`col-${colKey}`}
                                    checked={
                                      visibleColumns[
                                        colKey as keyof typeof visibleColumns
                                      ]
                                    }
                                    onChange={() => handleColumnToggle(colKey)}
                                  />
                                  <label
                                    htmlFor={`col-${colKey}`}
                                    className="checktoggle"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="form-sorts dropdown me-4">
                        <Link
                          to="#"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                        >
                          <i className="ti ti-filter-share" /> Filter
                        </Link>

                        <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                          <div className="filter-set-view">
                            <div className="filter-set-head">
                              <h4>
                                <i className="ti ti-filter-share" /> Filter
                              </h4>
                            </div>

                            <div className="accordion" id="accordionExample">
                              {/* Content Name Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "contentName"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("contentName")
                                    }
                                  >
                                    Content Name
                                  </Link>
                                </div>
                                {openAccordion === "contentName" && (
                                  <div className="filter-set-contents accordion-collapse collapse show">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Content Name"
                                          value={filterNamesSearch}
                                          onChange={(e) =>
                                            setFilterNamesSearch(e.target.value)
                                          }
                                        />
                                      </div>

                                      {uniqueNames
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(
                                              filterNamesSearch.toLowerCase()
                                            )
                                        )
                                        .map((name) => (
                                          <li key={name}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterNames.includes(
                                                    name
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      name,
                                                      filterNames,
                                                      setFilterNames
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {name}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueNames.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(
                                            filterNamesSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Content Type Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "contentType"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("contentType")
                                    }
                                  >
                                    Content Type
                                  </Link>
                                </div>

                                {openAccordion === "contentType" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Content Type"
                                          value={filterTypesSearch}
                                          onChange={(e) =>
                                            setFilterTypesSearch(e.target.value)
                                          }
                                        />
                                      </div>

                                      {uniqueTypes
                                        .filter((s) =>
                                          s
                                            .toLowerCase()
                                            .includes(
                                              filterTypesSearch.toLowerCase()
                                            )
                                        )
                                        .map((type) => (
                                          <li key={type}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterTypes.includes(
                                                    type
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      type,
                                                      filterTypes,
                                                      setFilterTypes
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {type}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueTypes.filter((s) =>
                                        s
                                          .toLowerCase()
                                          .includes(
                                            filterTypesSearch.toLowerCase()
                                          )
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Created At Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "createdAt"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("createdAt")
                                    }
                                  >
                                    Created At
                                  </Link>
                                </div>

                                {openAccordion === "createdAt" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Created At"
                                          value={createdAtSearch}
                                          onChange={(e) =>
                                            setCreatedAtSearch(e.target.value)
                                          }
                                        />
                                      </div>

                                      {uniqueCreatedAts
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(createdAtSearch.toLowerCase())
                                        )
                                        .map((date) => (
                                          <li key={date}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterCreatedAts.includes(
                                                    date
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      date,
                                                      filterCreatedAts,
                                                      setFilterCreatedAts
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {date}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueCreatedAts.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(createdAtSearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Last Modified Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "updatedAt"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("updatedAt")
                                    }
                                  >
                                    Last Modified
                                  </Link>
                                </div>

                                {openAccordion === "updatedAt" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Last Modified"
                                          value={updatedAtSearch}
                                          onChange={(e) =>
                                            setUpdatedAtSearch(e.target.value)
                                          }
                                        />
                                      </div>

                                      {uniqueUpdatedAts
                                        .filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(updatedAtSearch.toLowerCase())
                                        )
                                        .map((date) => (
                                          <li key={date}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterUpdatedAts.includes(
                                                    date
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      date,
                                                      filterUpdatedAts,
                                                      setFilterUpdatedAts
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {date}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueUpdatedAts.filter((n) =>
                                        n
                                          .toLowerCase()
                                          .includes(updatedAtSearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <hr className="my-2" />

                              {/* Created By Filter */}
                              <div className="filter-set-content">
                                <div className="filter-set-content-head">
                                  <Link
                                    to="#"
                                    className={
                                      openAccordion === "createdBy"
                                        ? ""
                                        : "collapsed"
                                    }
                                    onClick={() =>
                                      handleAccordionToggle("createdBy")
                                    }
                                  >
                                    Created By
                                  </Link>
                                </div>

                                {openAccordion === "createdBy" && (
                                  <div className="filter-set-contents accordion-collapse">
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Created By"
                                          value={createdBySearch}
                                          onChange={(e) =>
                                            setCreatedBySearch(e.target.value)
                                          }
                                        />
                                      </div>

                                      {uniqueCreatedBys
                                        .filter((s) =>
                                          s
                                            .toLowerCase()
                                            .includes(createdBySearch.toLowerCase())
                                        )
                                        .map((createdBy) => (
                                          <li key={createdBy}>
                                            <div className="filter-checks">
                                              <label className="checkboxs">
                                                <input
                                                  type="checkbox"
                                                  checked={filterCreatedBys.includes(
                                                    createdBy
                                                  )}
                                                  onChange={() =>
                                                    handleFilterChange(
                                                      createdBy,
                                                      filterCreatedBys,
                                                      setFilterCreatedBys
                                                    )
                                                  }
                                                />
                                                <span className="checkmarks" />{" "}
                                                {createdBy}
                                              </label>
                                            </div>
                                          </li>
                                        ))}

                                      {uniqueCreatedBys.filter((s) =>
                                        s
                                          .toLowerCase()
                                          .includes(createdBySearch.toLowerCase())
                                      ).length === 0 && (
                                        <p className="text-muted px-2">
                                          No data found
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Reset / Apply Buttons */}
                            <div className="filter-reset-btns mt-3">
                              <div className="row">
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-light w-100"
                                    onClick={() => {
                                      setFilterNames([]);
                                      setFilterTypes([]);
                                      setFilterCreatedAts([]);
                                      setFilterUpdatedAts([]);
                                      setFilterCreatedBys([]);
                                      setFilterNamesSearch("");
                                      setFilterTypesSearch("");
                                      setCreatedAtSearch("");
                                      setUpdatedAtSearch("");
                                      setCreatedBySearch("");
                                      setOpenAccordion(null);
                                    }}
                                  >
                                    Reset
                                  </Link>
                                </div>
                                <div className="col-6">
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    data-bs-dismiss="dropdown"
                                  >
                                    Apply
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div className="card-body">
                  {/* Table */}
                  <div className="table-responsive custom-table">
                    {error ? (
                      <div className="text-center text-danger my-4">
                        {error}
                      </div>
                    ) : (
                    <Table
                      dataSource={filteredDataMemo}
                      columns={visibleCols}
                      rowKey="content_id"
                      loading={loading}
                    />
                    )}
                  </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Content Message */}
      {showAdd && (
  <>
    {/* Backdrop */}
    <div
      className="offcanvas-backdrop fade show"
      style={{ zIndex: 1040 }}
      onClick={() => setShowAdd(false)} // ✅ close when clicking outside
    />

    {/* Offcanvas */}
    <div
      className="offcanvas offcanvas-end offcanvas-large show d-block"
      style={{ visibility: "visible", zIndex: 1050 }}
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Add Content Messages</h5>
        <button
          type="button"
          className="btn-close custom-btn-close"
          onClick={() => setShowAdd(false)} // ✅ close on X
        >
          <i className="ti ti-x" />
        </button>
      </div>
        <div
        className="offcanvas-body overflow-auto"
        style={{ maxHeight: "calc(100vh - 60px)" }}
      >
          <form onSubmit={(e) => handleSubmit(e, false)}>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-info-circle fs-20" />
                    </span>
                    Basic Information
                  </Link>
                </div>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Type <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option value="">Select Type</option>
                            <option value="1">Email</option>
                            <option value="2">SMS</option>
                            {/* <option value="3">WhatsApp</option> */}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Create Tag <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={tags.join(",")}
                            onChange={(e) =>
                              setTags(
                                e.target.value
                                  .split(",")
                                  .map((tag) => tag.trim())
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Description <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Access <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={access}
                            onChange={(e) => setAccess(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="Public">Public</option>
                            <option value="Private">Private</option>
                            <option value="Shared To">Shared To</option>
                          </select>
                        </div>

                        {access === "Shared To" && (
                          <div className="mb-3">
                            <label className="col-form-label">
                              Leads Owner <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              multiple
                              value={sharedOwners}
                              onChange={(e) =>
                                setSharedOwners(
                                  Array.from(
                                    e.target.selectedOptions,
                                    (opt) => opt.value
                                  )
                                )
                              }
                            >
                              {leads.map((lead) => (
                                <option
                                  key={lead.lead_id}
                                  value={lead.users.id}
                                >
                                  {lead.users.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {(type === "2" || type === "3") && (
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i
                          className={`ti ${type === "2"
                            ? "ti-message-2-code"
                            : "ti-brand-whatsapp"
                            } fs-20`}
                        />
                      </span>
                      {type === "2"
                        ? "SMS DLT Information"
                        : "WhatsApp Template Info"}
                    </Link>
                  </div>

                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        {type === "2" ? (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Template ID
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="DLT Template ID"
                                  value={dltTemplateId}
                                  onChange={(e) =>
                                    setDltTemplateId(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Approved
                                </label>
                                <select
                                  className="form-select"
                                  value={dltApproved}
                                  onChange={(e) =>
                                    setDltApproved(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="approved">Approved</option>
                                  <option value="pending">Pending</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Operator Name
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="DLT Operator Name"
                                  value={dltOperatorName}
                                  onChange={(e) =>
                                    setDltOperatorName(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Service Type
                                </label>
                                <select
                                  className="form-select"
                                  value={serviceType}
                                  onChange={(e) =>
                                    setServiceType(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="promotional">
                                    Promotional
                                  </option>
                                  <option value="transactional">
                                    Transactional
                                  </option>
                                  <option value="service_explict">
                                    Service Explicit
                                  </option>
                                  <option value="service_implict">
                                    Service Implicit
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Sender ID
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="Sender ID"
                                  value={senderId}
                                  onChange={(e) => setSenderId(e.target.value)}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Template ID/Name
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="Template ID/Name"
                                  value={whatsappTemplateId}
                                  onChange={(e) =>
                                    setWhatsappTemplateId(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  WhatsApp Type
                                </label>
                                <select
                                  className="form-select"
                                  value={whatsappType}
                                  onChange={(e) =>
                                    setWhatsappType(e.target.value)
                                  }
                                >
                                  <option value="text">Text</option>
                                  <option value="media">Media</option>
                                </select>
                              </div>
                            </div>

                            {whatsappType === "media" && (
                              <>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Media Type
                                    </label>
                                    <select
                                      className="form-select"
                                      value={mediaType}
                                      onChange={(e) =>
                                        setMediaType(e.target.value)
                                      }
                                    >
                                      <option value="">Select Media</option>
                                      <option value="image">Image</option>
                                      <option value="video">Video</option>
                                      <option value="document">Document</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Upload Media File
                                    </label>
                                    <input
                                      className="form-control"
                                      type="file"
                                      onChange={(e) =>
                                        setMediaFile(
                                          e.target.files
                                            ? e.target.files[0]
                                            : null
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {(type === "1" || type === "2" || type === "3") && (
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-edit-circle fs-20" />
                      </span>
                      Message Editor
                    </Link>
                  </div>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Module *</label>
                            <select
                              className="form-select"
                              value={module}
                              onChange={(e) => {
                                setModule(e.target.value);
                                setLeadFields([]);
                              }}
                            >
                              <option value="">Select</option>
                              <option value="lead">Lead Details</option>
                              <option value="contact">Contact Details</option>
                            </select>
                          </div>
                        </div>

                        {(module === "lead" || module === "contact") && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="col-form-label">
                                {module === "lead" ? "Lead Fields *" : "Contact Fields *"}
                              </label>
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                menuPlacement="auto"
                                options={
                                  module === "lead"
                                    ? Object.keys(leads[0] || {}).map((field) => ({
                                      label: field,
                                      value: field,
                                    }))
                                    : leads[0]?.contact
                                      ? Object.keys(leads[0].contact).map((field) => ({
                                        label: field,
                                        value: field,
                                      }))
                                      : []
                                }
                                value={leadFields.map((f) => ({
                                  label: f,
                                  value: f,
                                }))}
                                onChange={(selected) => {
                                  const values = selected.map((s) => s.value);
                                  updateMessageWithFields(values, leadFields, setLeadFields);
                                }}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: 'auto',
                                    minWidth: '100%',
                                    flexWrap: 'wrap',
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    flexWrap: 'wrap',
                                    maxHeight: 'auto',
                                    overflowY: 'auto',
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    margin: '2px',
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Agent Fields *</label>
                            <Select
                              isMulti
                              closeMenuOnSelect={false}
                              menuPlacement="auto"
                              options={
                                clientDetail
                                  ? Object.keys(clientDetail).map((field) => ({
                                    label: field,
                                    value: field,
                                  }))
                                  : []
                              }
                              value={agentFields.map((f) => ({
                                label: f,
                                value: f,
                              }))}
                              onChange={(selected) => {
                                const values = selected.map((s) => s.value);
                                updateMessageWithFields(values, agentFields, setAgentFields);
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: 'auto',
                                  minWidth: '100%',
                                  flexWrap: 'wrap',
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  flexWrap: 'wrap',
                                  maxHeight: 'auto',
                                  overflowY: 'auto',
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  margin: '2px',
                                }),
                              }}
                            />
                          </div>
                        </div>


                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={4}
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                            <div className="text-end text-muted small mt-1">
                              {message.length} characters
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end mt-4 gap-2">
              <button
  type="button"
  className="btn btn-light"
  onClick={() => {
    resetForm();
    setShowAdd(false); 
  }}
>
  Cancel
</button>

              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={resetForm}
              >
                Clear All
              </button>
              <button type="submit" className="btn btn-primary">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      </>
      )}
      {/* Edit Content Message */}
      {showEdit && (
  <>
   
    <div
      className="offcanvas-backdrop fade show"
      style={{ zIndex: 1040 }}
      onClick={() => setShowEdit(false)} 
    />

  
    <div
      className="offcanvas offcanvas-end offcanvas-large show d-block"
      style={{ visibility: "visible", zIndex: 1050 }}
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Edit Content Messages</h5>
        <button
          type="button"
          className="btn-close custom-btn-close"
          onClick={() => setShowEdit(false)} // ✅ close on X
        >
          <i className="ti ti-x" />
        </button>
      </div>
        <div
        className="offcanvas-body overflow-auto"
        style={{ maxHeight: "calc(100vh - 60px)" }}
      >
          <form onSubmit={(e) => handleSubmit(e, true)}>
            <div className="accordion" id="accordionEdit">
              <div className="accordion-item rounded mb-3">
                <div className="accordion-header">
                  <Link
                    to="#"
                    className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEditOne"
                  >
                    <span className="avatar avatar-md rounded text-dark border me-2">
                      <i className="ti ti-info-circle fs-20" />
                    </span>
                    Basic Information
                  </Link>
                </div>
                <div
                  id="collapseEditOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionEdit"
                >
                  <div className="accordion-body border-top">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Type <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option value="">Select Type</option>
                            <option value="1">Email</option>
                            <option value="2">SMS</option>
                            <option value="3">WhatsApp</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Create Tag <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={tags.join(",")}
                            onChange={(e) =>
                              setTags(
                                e.target.value
                                  .split(",")
                                  .map((tag) => tag.trim())
                              )
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Description <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Access <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={access}
                            onChange={(e) => setAccess(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="Public">Public</option>
                            <option value="Private">Private</option>
                            <option value="Shared To">Shared To</option>
                          </select>
                        </div>

                        {access === "Shared To" && (
                          <div className="mb-3">
                            <label className="col-form-label">
                              Leads Owner <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              multiple
                              value={sharedOwners}
                              onChange={(e) =>
                                setSharedOwners(
                                  Array.from(
                                    e.target.selectedOptions,
                                    (opt) => opt.value
                                  )
                                )
                              }
                            >
                              {leads.map((lead) => (
                                <option
                                  key={lead.lead_id}
                                  value={lead.users.id}
                                >
                                  {lead.users.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {(type === "2" || type === "3") && (
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEditTwo"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i
                          className={`ti ${type === "2"
                            ? "ti-message-2-code"
                            : "ti-brand-whatsapp"
                            } fs-20`}
                        />
                      </span>
                      {type === "2"
                        ? "SMS DLT Information"
                        : "WhatsApp Template Info"}
                    </Link>
                  </div>
                  <div
                    id="collapseEditTwo"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#accordionEdit"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        {type === "2" ? (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Template ID
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="DLT Template ID"
                                  value={dltTemplateId}
                                  onChange={(e) =>
                                    setDltTemplateId(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Approved
                                </label>
                                <select
                                  className="form-select"
                                  value={dltApproved}
                                  onChange={(e) =>
                                    setDltApproved(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="approved">Approved</option>
                                  <option value="pending">Pending</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  DLT Operator Name
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="DLT Operator Name"
                                  value={dltOperatorName}
                                  onChange={(e) =>
                                    setDltOperatorName(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Service Type
                                </label>
                                <select
                                  className="form-select"
                                  value={serviceType}
                                  onChange={(e) =>
                                    setServiceType(e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="promotional">
                                    Promotional
                                  </option>
                                  <option value="transactional">
                                    Transactional
                                  </option>
                                  <option value="service_explict">
                                    Service Explicit
                                  </option>
                                  <option value="service_implict">
                                    Service Implicit
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Sender ID
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="Sender ID"
                                  value={senderId}
                                  onChange={(e) => setSenderId(e.target.value)}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  Template ID/Name
                                </label>
                                <input
                                  className="form-control"
                                  placeholder="Template ID/Name"
                                  value={whatsappTemplateId}
                                  onChange={(e) =>
                                    setWhatsappTemplateId(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="col-form-label">
                                  WhatsApp Type
                                </label>
                                <select
                                  className="form-select"
                                  value={whatsappType}
                                  onChange={(e) =>
                                    setWhatsappType(e.target.value)
                                  }
                                >
                                  <option value="text">Text</option>
                                  <option value="media">Media</option>
                                </select>
                              </div>
                            </div>

                            {whatsappType === "media" && (
                              <>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Media Type
                                    </label>
                                    <select
                                      className="form-select"
                                      value={mediaType}
                                      onChange={(e) =>
                                        setMediaType(e.target.value)
                                      }
                                    >
                                      <option value="">Select Media</option>
                                      <option value="image">Image</option>
                                      <option value="video">Video</option>
                                      <option value="document">Document</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="col-form-label">
                                      Upload Media File
                                    </label>
                                    <input
                                      className="form-control"
                                      type="file"
                                      onChange={(e) =>
                                        setMediaFile(
                                          e.target.files
                                            ? e.target.files[0]
                                            : null
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {(type === "1" || type === "2" || type === "3") && (
                <div className="accordion-item rounded mb-3">
                  <div className="accordion-header">
                    <Link
                      to="#"
                      className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEditThree"
                    >
                      <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-edit-circle fs-20" />
                      </span>
                      {type === "1"
                        ? "Email"
                        : type === "2"
                          ? "SMS"
                          : "WhatsApp"}{" "}
                      Message Editor
                    </Link>
                  </div>
                  <div
                    id="collapseEditThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionEdit"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">Module *</label>
                            <select
                              className="form-select"
                              value={module}
                              onChange={(e) => {
                                setModule(e.target.value);
                                setLeadFields([]);
                              }}
                            >
                              <option value="">Select</option>
                              <option value="lead">Lead Details</option>
                              <option value="contact">Contact Details</option>
                            </select>
                          </div>
                        </div>

                        {(module === "lead" || module === "contact") && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="col-form-label">
                                {module === "lead"
                                  ? "Lead Fields *"
                                  : "Contact Fields *"}
                              </label>
                              <Select
                                isMulti
                                options={
                                  module === "lead"
                                    ? Object.keys(leads[0] || {}).map(
                                      (field) => ({
                                        label: field,
                                        value: field,
                                      })
                                    )
                                    : leads[0]?.contact
                                      ? Object.keys(leads[0].contact).map(
                                        (field) => ({
                                          label: field,
                                          value: field,
                                        })
                                      )
                                      : []
                                }
                                value={leadFields.map((f) => ({
                                  label: f,
                                  value: f,
                                }))}
                                onChange={(selected) => {
                                  const values = selected.map((s) => s.value);
                                  updateMessageWithFields(
                                    values,
                                    leadFields,
                                    setLeadFields
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Agent Fields *
                            </label>
                            <Select
                              isMulti
                              options={
                                clientDetail
                                  ? Object.keys(clientDetail).map((field) => ({
                                    label: field,
                                    value: field,
                                  }))
                                  : []
                              }
                              value={agentFields.map((f) => ({
                                label: f,
                                value: f,
                              }))}
                              onChange={(selected) => {
                                const values = selected.map((s) => s.value);
                                updateMessageWithFields(
                                  values,
                                  agentFields,
                                  setAgentFields
                                );
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="col-form-label">
                              Message <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={4}
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                            <div className="text-end text-muted small mt-1">
                              {message.length} characters
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end mt-4 gap-2">
              <button
  type="button"
  className="btn btn-light"
  onClick={() => {
    resetForm();
    setShowEdit(false); // ✅ close
  }}
>
  Cancel
</button>

              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={resetForm}
              >
                Clear All
              </button>
              <button type="submit" className="btn btn-primary">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
      </>
      )}
      {/* Delete Content Message */}
      <div
        className="modal fade"
        id="delete_contact"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="deleteContactLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-alert-triangle fs-36 text-danger" />
                </div>
                <h5 className="fw-semibold text-danger" id="deleteContactLabel">
                  Remove Content Message
                </h5>
                <p className="text-muted mb-0">Are you sure you want to remove it?</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={handleDelete}
                  >
                    Yes, Delete it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ContentMessages;
